var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicalFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 2C17.5231 2.00026 22.0005 6.47732 22.0005 12C22.0005 17.5227 17.5231 21.9997 12.0005 22C6.47764 22 2.00049 17.5228 2.00049 12C2.00049 6.47715 6.47764 2 12.0005 2ZM10.7935 6.04102C10.3795 6.04128 10.0444 6.37697 10.0444 6.79102V10.0439H6.79053C6.37654 10.0442 6.04053 10.3799 6.04053 10.7939V13.2061C6.04053 13.6201 6.37654 13.9558 6.79053 13.9561H10.0444V17.209C10.0444 17.623 10.3795 17.9597 10.7935 17.96H13.2065C13.6205 17.9598 13.9563 17.6239 13.9565 17.21V13.9561H17.2095C17.6237 13.9561 17.9595 13.6203 17.9595 13.2061V10.7939C17.9595 10.3797 17.6237 10.0439 17.2095 10.0439H13.9565V6.79102C13.9565 6.37687 13.6207 6.04113 13.2065 6.04102H10.7935Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalFilled);
export default __webpack_public_path__ + "static/media/medical-filled.191e0e219b4443eb584eb3a4c76e8793.svg";
export { ForwardRef as ReactComponent };